import { render } from "./TheEditor.vue?vue&type=template&id=4bcfdb64&scoped=true"
import script from "./TheEditor.vue?vue&type=script&lang=js"
export * from "./TheEditor.vue?vue&type=script&lang=js"

import "./TheEditor.vue?vue&type=style&index=0&id=4bcfdb64&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcfdb64"]])

export default __exports__